export default class CustomFieldDefinitionApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key || null
    this.BusinessUnitKey = rawModel?.BusinessUnitKey || null
    this.ObjectType = rawModel?.ObjectType || null // [ Unknown, NoRelatedObject, User, Booking, BookingProduct, BookingProductProperty, BookingRemark, BusinessUnit, BusinessUnitSetting, Product, Activity, Resource, ShoppingCart, Payment, CustomFieldDefinition ]
    this.FieldCode = rawModel?.FieldCode || null
    this.FieldName = rawModel?.FieldName || null
    this.Description = rawModel?.Description || null
    this.Datatype = rawModel?.Datatype || null // [ NotSet, String, Integer, Decimal, Date, Datetime, Time, Boolean ]
    this.MaxOccurs = rawModel?.MaxOccurs || null
    this.Optional = rawModel?.Optional === true ? true : false
    this.MaxLength = rawModel?.MaxLength || null
  }
}
